import AreaList from "./AreaList";
export * from "./AreaList";
export default AreaList;